import { formatUtcDateTime, formatUtcTime } from '../../lib/time';

/** Score / trend helpers for the Entity Risk Index. */

export function toScoreNumber(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) ? n : null;
}

export function scoreCls(score: number): string {
  return score >= 80 ? 'sc-hi' : score >= 65 ? 'sc-md' : 'sc-lo';
}

/** Only a score that needs attention is coloured (colour rule 3): red from 80, neutral below. Honey is for what waits on a person. */
export function scoreColor(score: number): string {
  return score >= 80 ? 'var(--c3-red)' : 'var(--t3)';
}

export function trendClass(delta: number): string {
  return delta > 0 ? 'tr-up' : delta < 0 ? 'tr-dn' : '';
}

export function trendLabel(delta: number): string {
  if (delta > 0) return `▲ ${Math.round(delta)}`;
  if (delta < 0) return `▼ ${Math.abs(Math.round(delta))}`;
  return '· 0';
}

export function eriBand(score: number): string {
  if (score >= 80) return 'high';
  if (score >= 65) return 'medium';
  return 'low';
}

/** "14:32:07 UTC". The console writes time in UTC only (item 76). */
export function formatClock(iso?: string): string {
  return formatUtcTime(iso);
}

/** "2026-10-28 14:32 UTC". */
export function formatDate(iso?: string): string {
  return formatUtcDateTime(iso);
}

export function formatTerm(value: unknown): string {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toFixed(2);
}

export function normalizeSeverityToScore(severity: number | undefined): number | null {
  if (severity == null || !Number.isFinite(severity)) return null;
  if (severity <= 100 && severity >= 0) return Math.round(severity);
  return Math.max(0, Math.min(100, Math.round(severity)));
}
